import { render } from "./iconRefund.vue?vue&type=template&id=0734aeb0"
import script from "./iconRefund.vue?vue&type=script&lang=js"
export * from "./iconRefund.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__